import { Directive, EventEmitter, HostBinding, HostListener, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Directive({
  selector: '[appFiledrop]',
  standalone:true,
})
export class FiledropDirective {
  
  //@Input() private allowed_extensions : Array<string> = ['png', 'jpg', 'bmp'];
  @Output() private filesChangeEmiter: EventEmitter<File[]> = new EventEmitter();
  //@Output() private filesInvalidEmiter : EventEmitter<File[]> = new EventEmitter();
  @HostBinding('style.background') private background = 'rgba(236, 241, 240, 0.70)';
  @HostBinding('style.border') private borderStyle = '2px dashed';
  @HostBinding('style.border-color') private borderColor = '#B5BAB9';
  @HostBinding('style.border-radius') private borderRadius = '30px';



  constructor(private toast:ToastrService) { }

  @HostListener('dragover', ['$event']) public onDragOver(evt: { preventDefault: () => void; stopPropagation: () => void; }) {
    evt.preventDefault();
    evt.stopPropagation();
    this.borderColor = '#3267ff';
  }

  @HostListener('dragleave', ['$event']) public onDragLeave(evt: { preventDefault: () => void; stopPropagation: () => void; }) {
    evt.preventDefault();
    evt.stopPropagation();
    this.background = 'rgba(236, 241, 240, 0.70)';
    this.borderColor = '#B5BAB9';
    this.borderStyle = '2px dashed';
  }

  @HostListener('drop', ['$event']) public onDrop(evt: { preventDefault: () => void; stopPropagation: () => void; dataTransfer: { files: any; }; }) {
    evt.preventDefault();
    evt.stopPropagation();
    this.background = 'rgba(236, 241, 240, 0.70)';
    this.borderColor = '#3267ff';
    this.borderStyle = '2px dashed';
    let files = evt.dataTransfer.files;
    let fileTypes = ['csv']
    let valid_files: Array<File> = files;
    let invC =true
    for (let i = 0; i < valid_files.length; i++) {
      const file = String(files[0].name).split('.')[String(files[0].name).split('.').length-1];
      if(!fileTypes.includes(file))
      {
        invC=false;
      }
    }
    if(invC)
    {
      this.filesChangeEmiter.emit(valid_files);
    }
    else{
      this.borderColor = '#B5BAB9';
      this.toast.warning('Invalid doc');
    }
  
  }
}
